import React from 'react'

const AnimationSection = () => {
  return (
    <section className="py-16 sm:py-20 bg-gradient-to-b from-purple-50 to-pink-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-12">
          
          {/* Lottie Animation */}
          <div className="w-full lg:w-1/2">
            <iframe
              src="https://lottie.host/embed/afb8f3cb-24c0-46df-99e0-145d8bf9bd99/07QDFkbngt.lottie"
              width="100%"
              height="300"
              className="sm:h-[350px] lg:h-[400px] rounded-lg shadow-lg"
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>

          {/* Text Content */}
          <div className="w-full lg:w-1/2 lg:pl-8 xl:pl-12 mt-8 lg:mt-0 text-center lg:text-left">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 mb-4 sm:mb-6">
              Dance Like Nobody&apos;s Watching
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed">
              Whether you&apos;re a beginner or a pro, our platform helps you unleash
              your inner dancer. With personalized lessons, AI-powered feedback,
              and a global community, you&apos;ll be dancing like a star in no time!
            </p>
            <button className="px-6 sm:px-8 py-2.5 sm:py-3 text-base sm:text-lg font-semibold bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full hover:from-pink-500 hover:to-purple-500 transition-all shadow-md">
              Join the Movement
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AnimationSection
